import EllipseMode from "../../shapes/modes/EllipseMode";
import LineMode from "../../shapes/modes/LineMode";
import PolygonMode from "../../shapes/modes/PolygonMode";
import RectangleMode from "../../shapes/modes/RectangleMode";
import { onCanvas } from "../../shared/mouseFunctions";
import AbstractTool from "../AbstractTool";

export default class ShapesTool extends AbstractTool {
    scrollEnabled = true;
    resetPreviousTool = true;

    constructor(provider) {
        super(provider);

        this.modes = {
            'rectangle': new RectangleMode(provider),
            'polygon': new PolygonMode(provider),
            'line': new LineMode(provider),
            'ellipse': new EllipseMode(provider),
        };

        this.currentMode = this.modes['rectangle'];
    }

    activate(speciesId) {
        super.activate();
        if (!this.mobile || this.sideBar.isOpen) {
            this.sideBar.setTab('info');
        }
        this.getTab('info').drawMode();
        this.passArgs(speciesId);
        this.drawMenu.show('draw');
        this.currentMode.activate();
    }

    deactivate() {
        super.deactivate();
        this.getTab('info').noMode();
        this.drawMenu.hide();
        this.currentMode.deactivate();
        this.provider.menu.resetCurrentToolIcon();
    }

    passArgs(speciesId) {
        this.getTab('info').drawInput.setSpecies(speciesId);
        this.speciesId = speciesId;
    }


    setMode(mode) {
        let newMode = this.modes[mode];
        if (newMode == this.currentMode) {
            return;
        }

        this.currentMode.deactivate();
        this.currentMode = newMode;
        this.currentMode.activate();
    }

    display(g) {
        this.currentMode.display(g);
    }

    pressMouseOnCanvas() {
        this.currentMode.pressMouseOnCanvas();
    }

    doubleClickedOnCanvas() {
        return this.currentMode.doubleClickedOnCanvas();
    }

    moveMouse() {
        if (onCanvas(this.provider)) {
            this.cursor.cross();
            this.currentMode.mouseMoved();
        }
    }

    makeSticky(inputField) {
        this.currentMode.makeSticky(inputField);
    }

    getTips() {
        return this.currentMode.getTips();
    }

    pressKeyWithShift(code) {
        switch (code) {
            case 75: // K
                this.drawMenu.stroke = !this.drawMenu.stroke;
                return false;
            case 88: // X
                this.drawMenu.fill = !this.drawMenu.fill;
                return false;
        }
        return;
    }

    pressKeyHotKeysDisabled(code) {
        switch (code) {
            case 13: // ENTER
                this.currentMode.makeShape();
                return;
            case 27: // Esc
                this.currentMode.resetSticky();
                setTimeout(() => {
                    this.getTab('info').activeInput.elt.blur();
                }, 10);
                return;
        }
        return;
    }

    pressKey(code) {
        switch (code) {
            case 13: // ENTER
                this.currentMode.makeShape();
                return;
            case 27: // ESC
                this.currentMode.reset();
                return;
            case 82: // R
                this.setMode('rectangle');
                this.drawMenu.modeSelector.selected('rectangle');
                return;
            case 70: // F
                this.setMode('polygon');
                this.drawMenu.modeSelector.selected('polygon');
                return;
            case 75: // K
                setTimeout(() => this.drawMenu.strokePicker.elt.click(), 10);
                return;
            case 79: // O
                this.setMode('ellipse');
                this.drawMenu.modeSelector.selected('ellipse');
                return;
            case 88: // X
                setTimeout(() => this.drawMenu.fillPicker.elt.click(), 10);
                return;
            case 89: // Y
                this.setMode('line');
                this.drawMenu.modeSelector.selected('line');
                return;
        }

        return this.currentMode.pressKey(code);
    }
}
